<template>
    <div class="modal modal_payers" id="modalPayer" tabindex="-1" role="dialog" aria-hidden="true" ref="modalPayer">        
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">

                    <h5 class="modal-title title">Выбор плательщика</h5>
                    <button type="button" class="btn btn_lg btn_common btn_icononly" data-dismiss="modal" id="modalPayerClose" ref="modalPayerClose"><i
                            class="f7-icons icon_lg">xmark</i></button>

                </div>
                <div class="modal-body">

                    <order-form-payer-items v-bind:checkable="checkable"></order-form-payer-items>
                    <order-form-payer-form></order-form-payer-form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        checkable: {
            default: true,
            type: Boolean,
        }
    },
    data: function () {
        return {
        }
    },
    methods: {
    },
    computed: {
    },
};
</script>
